module.exports = __webpack_public_path__ + "141d4a85/img/rename-icon.de4e673d.svg";